var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',_vm._g(_vm._b({class:['grey--text', 'text--darken-2', {'mt-10':!_vm.noMarginTop}]},'h4',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }